<footer class="footer">
    <div class="footer__inner rs-container">
        <div class="footer__brand">
            <img class="footer__brand__mark"
                 src="assets/img/logos/rettensteiner-mark-trimmed.png"
                 alt="Metzgerei Rettensteiner-Scharfetter">
            <p class="footer__brand__name">Metzgerei<br>Rettensteiner-Scharfetter</p>
            <p class="footer__brand__claim">Fleisch mit Herkunft,<br>Handwerk mit Herz.</p>
            <div class="footer__social">
                <a href="https://www.facebook.com/profile.php?id=100063801932792"
                   target="_blank"
                   rel="noopener"
                   aria-label="Facebook">
                    <img src="assets/icon/facebook.svg" alt="">
                </a>
                <a href="https://www.instagram.com/marktstubn/"
                   target="_blank"
                   rel="noopener"
                   aria-label="Instagram">
                    <img src="assets/icon/instagram.svg" alt="">
                </a>
            </div>
        </div>

        <div class="footer__col">
            <p class="footer__col__title">Kontakt</p>
            <a href="https://www.openstreetmap.org/?mlat=47.3469044&mlon=13.2023823#map=18/47.34690/13.20238"
               target="_blank"
               rel="noopener">Hans Kappacherstraße 9<br>5600 St. Johann im Pongau</a>
            <a href="tel:+43641220245">+43 (0) 6412 20 245</a>
            <a href="mailto:rettensteiner.office@sbg.at">rettensteiner.office&#64;sbg.at</a>
        </div>

        <div class="footer__col">
            <p class="footer__col__title">Öffnungszeiten</p>
            <p>Mo – Fr &nbsp;07:30 – 18:00 Uhr</p>
            <p>Samstag &nbsp;07:00 – 12:00 Uhr</p>
            <p>Sonntag &nbsp;geschlossen</p>
        </div>

        <div class="footer__col">
            <p class="footer__col__title">Entdecken</p>
            <a routerLink="/speiseplan">Speiseplan &amp; Wochenkarte</a>
            <a href="https://www.metzgerei-rettensteiner-scharfetter.at/speisekarte.pdf"
               target="_blank"
               rel="noopener">Speisekarte</a>
            <a routerLink="/qualität">Qualität</a>
            <a href="https://bestellen.marktstubn.com/" target="_blank" rel="noopener">Vorbestellen</a>
        </div>
    </div>

    <div class="footer__bar rs-container">
        <p>© {{currentYear}} Rettensteiner Robert GmbH</p>
        <a class="footer__bar__legal" routerLink="/kontakt" (click)="clickedImpressum()">
            Impressum &amp; Datenschutzerklärung
        </a>
        <a class="footer__bar__host" href="https://www.skillagentur.com" target="_blank" rel="noopener">
            <span>Umgesetzt von</span>
            <img src="assets/img/logos/skillagentur-logo.svg" alt="Skill Agentur">
        </a>
    </div>
</footer>
